import {Component} from "react";

export default class GraphicsCleaner extends Component {
    render() {
        return null;
    }
    componentDidMount() {
        if (this.props.layerId) {
            let layer = this.props.map.findLayerById(this.props.layerId);
            if (layer) {
                layer.graphics.removeAll();
            }
        }

        this.props.view.graphics.removeAll();
    }
}